import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

import img1 from "../assets/image/cps 001.jpg";
import img2 from "../assets/image/cps 002.jpeg";
import img3 from "../assets/image/cps 003.jpg";
import img4 from "../assets/image/1.jpeg";
import img5 from "../assets/image/6x4 copy.jpg"; 

import { Link } from "react-router-dom";

function Hero() {
  const images = [img1, img2, img3, img4, img5];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(slider);
  }, [images.length]);

  return (
    <section className="relative h-[90vh] w-full overflow-hidden">

      {/* Images */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            current === index ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <img
            src={img}
            alt={`slide-${index}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}

      {/* Overlay (optional but recommended) */}
      <div className="absolute inset-0 bg-black/40 z-20" />

      {/* Hero Content */}
        <div className="absolute inset-0 z-20 flex items-center justify-center text-center px-6">

          <div className="max-w-4xl">

            {/* Small Tag */}
            <div className="inline-block bg-yellow-400 text-blue-900 px-5 py-2 rounded-full font-bold text-sm mb-6 shadow-lg">
              Academic Year 2026–27
            </div>

            {/* Main Heading */}
            <h1 className="text-4xl md:text-7xl font-extrabold text-white leading-tight mb-6 drop-shadow-lg">
              Registration For <br />

              <span className="text-yellow-400">
                Admission Open
              </span>
            </h1>

            {/* Sub Text */}
            <p className="text-white/90 text-lg md:text-2xl mb-8 max-w-2xl mx-auto">
              Building a New Generation with Excellence,
              Discipline, Leadership & Holistic Learning.
            </p>

            {/* Buttons */}
          
            <div className="flex flex-col sm:flex-row justify-center gap-5">

              <Link
                to="/admissions"
                className="bg-yellow-400 hover:bg-white text-blue-900 px-8 py-4 rounded-full font-bold text-lg transition duration-300 shadow-xl"
              >
                Apply Now
              </Link>

              <Link
                to="/contact"
                className="border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 rounded-full font-bold text-lg transition duration-300"
              >
                Contact Us
              </Link>

            </div>

          </div>

        </div>

      {/* Arrows */}
      <button
        onClick={() =>
          setCurrent((prev) => (prev - 1 + images.length) % images.length)
        }
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 bg-white/20 p-3 rounded-full text-white hover:bg-yellow-400 hover:text-blue-900"
      >
        <ChevronLeft size={28} />
      </button>

      <button
        onClick={() =>
          setCurrent((prev) => (prev + 1) % images.length)
        }
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 bg-white/20 p-3 rounded-full text-white hover:bg-yellow-400 hover:text-blue-900"
      >
        <ChevronRight size={28} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex gap-3">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`h-3 rounded-full transition-all ${
              current === index ? "bg-yellow-400 w-8" : "bg-white/60 w-3"
            }`}
          />
        ))}
      </div>
    </section>
  );
}

export default Hero;